var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTryNewsBlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 42,
    viewBox: "0 0 80 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58 29a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm4-2a3.986 3.986 0 0 1-1.094 2.75A6.006 6.006 0 0 1 63.917 34h-2.043a4.002 4.002 0 0 0-7.748 0h-2.043a6.006 6.006 0 0 1 3.011-4.25A4 4 0 1 1 62 27Z",
    fill: "#010334"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 4v12h10a4 4 0 0 1 4 4v18c0 .729-.195 1.412-.535 2H79a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2h5.535A3.981 3.981 0 0 1 6 38V4a4 4 0 0 1 4-4h46a4 4 0 0 1 4 4ZM10 2h46a2 2 0 0 1 2 2v12h-2V5a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v32a1 1 0 0 0 1 1h31c0 .729.195 1.412.535 2H10a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Zm44 4v10h-8a4 4 0 0 0-4 4v16H12V6h42ZM44 20a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H46a2 2 0 0 1-2-2V20Zm4 16V22h20v14H48Zm-2-15a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H47a1 1 0 0 1-1-1V21Z",
    fill: "#CBD4D5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 11a1 1 0 0 0-1 1v1l-14 5a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0l2.189.782a4 4 0 0 0 7.532 2.69L37 27v1a1 1 0 1 0 2 0V12a1 1 0 0 0-1-1Zm-1 14V15l-14 5 14 5Zm-9.925-1.545 3.76 1.343a2 2 0 0 1-3.76-1.343Z",
    fill: "#2156FA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTryNewsBlock);
export default __webpack_public_path__ + "static/media/Try News Block.75640dbc33bafafea5e65de7e203174a.svg";
export { ForwardRef as ReactComponent };